import React from 'react';
import styled from 'styled-components';

export const AuctioneerName = () => (
  <AuctioneerContainer>
    <div>
      <div>Auctioneer:</div>
      <div>{'{Name Here}'}</div>
    </div>
  </AuctioneerContainer>
);

export default AuctioneerName;

export const AuctioneerContainer = styled.div`
  grid-area: auctioneerName;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #eee;
  border: 1px solid gray;
  padding: 0px 5px;
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.3em;
    text-transform: none;
    & div:first-child {
      font-weight: bold;
      margin: 5px;
    }
    & div:last-child {
      margin: 5px;
    }
  }
`;
